if (!customElements.get('gallery-panel')) {
  customElements.define('gallery-panel', class GalleryPanel extends HTMLElement {
    constructor() {
      super();

      this.allowZoomElements = this.querySelectorAll('.gallery_panel--item[data-modal-id]');
      this.allModals = this.querySelectorAll('.gallery-panel-modal');
      this.header = document.querySelector('.section-header');
    }

    connectedCallback() {
      this.allowZoomElements.forEach((element) => {
        element.addEventListener('click', this.openModal.bind(this, element));
      });

      this.allModals.forEach((modal) => {
        modal.querySelector('.close-icon').addEventListener('click', this.closeModal.bind(this));
      });

      this.addEventListener('click', (e) => {
        if (e.target.classList.contains('gallery-panel-modal')) this.closeModal(e);
      });
    }

    openModal(element) {
      const modalId = element.dataset.modalId;
      const modal = this.querySelector(`#${modalId}`);
      modal.classList.remove('hidden');
      if (this.header) this.header.classList.add('hidden');
    }

    closeModal(e) {
      const modal = e.target.closest('.gallery-panel-modal');
      modal.classList.add('hidden');
      if (this.header) this.header.classList.remove('hidden');
    }
  });
}
